import {trackProductTileGallerySwipe} from '@aboutyou/legacy-tracking-sdk';
import {useTracking} from '../utils/utils';

export const useTrackProductTileGallerySwipe = () => {
  const {TrackingClient} = useTracking();

  return (options: {
    name?: string;
    sponsored: boolean;
    sponsoredType?: string;
    sortingChannel: string;
    itemId: number;
    locationId: string;
    creativeName?: string;
    promotionId?: string;
  }) => {
    TrackingClient.track(trackProductTileGallerySwipe(options));
  };
};
